// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvacidadeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for salvaCidade() /localidades/salvaCidade
 *
 * Proxy to locations-service (Go microservice).
 * Returns the saved city record.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_SalvacidadeResponseDados {
id?: number
name?: string
state_id?: number
}

export type Localidades_SalvacidadeResponse = ApiResponse<Localidades_SalvacidadeResponseDados>;

registerResponseContract('Localidades_SalvacidadeResponse', {
  id:       { type: 'number',  required: false },
  name:     { type: 'string',  required: false },
  state_id: { type: 'number',  required: false },
})
